import { tns } from "tiny-slider/src/tiny-slider";

$(document).ready(() => {
    initCarousels();

    var resizeTimer;
    $(window).resize(() => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            refreshCarousels();
        }, 250);
    });
});

let carousels = [];

function refreshCarousels()
{
    carousels.forEach((slider, i) => {
        slider.destroy();
        delete carousels[i];
    });

    initCarousels();
}

// Loads all carousels
function initCarousels()
{
    // 4 card card block
    if($('.tns-promo-block').html()) {
        let tnsPromoBlock = document.querySelectorAll('.tns-promo-block');
        tnsPromoBlock.forEach(slider => {
            carousels.push(tns({
                container: slider,
                items: 1,
                loop: true,
                autoplay: true,
                autoplayButtonOutput: false,
                slideBy: 1,
                controls: true,
                controlsPosition: 'bottom',
                controlsText: ['<span class="fas fa-arrow-left"></span>', '<span class="fas fa-arrow-right"></span>'],
                controlsContainer: '#controlsContainer',
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                navContainer: '#navContainer',
                gutter: 20,
                responsive: {
                    640: {
                        items: 2,
                        autoWidth: true
                    }
                }
            }));

            // This removes unneeded carousel nav buttons - 1 button is needed per page, any more will break the nav buttons.
            carousels.forEach(slider => {
                let count = slider.getInfo().pages;
                let node = document.getElementById('navContainer');
                while(node.childElementCount > count) {
                    node.removeChild(node.lastChild);
                }
            })
        });

    }



    // 4 card block
    if($('.tns-cross-sell-block').html()) {
        let tnsPromoBlock = document.querySelectorAll('.tns-cross-sell-block');
        tnsPromoBlock.forEach(slider => {
            carousels.push(tns({
                container: slider,
                items: 1,
                mode: 'gallery',
                "loop": true,
                controls: false,
                controlsPosition: 'bottom',
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                gutter: 0,
                responsive: {
                    640: {
                        items: 4,
                        autoWidth: true,
                        gutter: 20
                    }
                }
            }));
        });
    }

    // 4 card block
    if($('.tns-wiring-kit-block').html()) {
        let tnsPromoBlock = document.querySelectorAll('.tns-wiring-kit-block');
        tnsPromoBlock.forEach(slider => {
            carousels.push(tns({
                container: slider,
                items: 1,
                mode: 'gallery',
                "loop": true,
                controls: false,
                controlsPosition: 'bottom',
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                gutter: 0,
                responsive: {
                    640: {
                        items: 4,
                        autoWidth: true,
                        gutter: 20
                    }
                }
            }));
        });
    }

    // 4 card block
    if($('.tns-upsell-block').html()) {
        let tnsPromoBlock = document.querySelectorAll('.tns-upsell-block');
        tnsPromoBlock.forEach(slider => {
            carousels.push(tns({
                container: slider,
                items: 1,
                mode: 'gallery',
                "loop": true,
                controls: false,
                controlsPosition: 'bottom',
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                gutter: 0,
                responsive: {
                    640: {
                        items: 4,
                        autoWidth: true,
                        gutter: 20
                    }
                }
            }));
        });
    }

    // image-gallery - Images on Product page - Desktop
    if($('.image-gallery').html()) {
        // Thumbanils
        let tnsProductGalleryBlock = document.querySelectorAll('.image-gallery--thumbnails');
        tnsProductGalleryBlock.forEach(slider => {
            carousels.push(tns({
                "container": slider,
                "items": 5,
                "axis": "vertical",
                nav: false,
                "controlsText": ["", ""],
                loop: false
            }));
        });

        // Main image.  The nav references the other carousel's images
        let tnsProductGalleryBlockMain = document.querySelectorAll('.image-gallery');
        tnsProductGalleryBlockMain.forEach(slider => {
            carousels.push(tns({
                "container": "#customize",
                "items": 1,
                "mode": "gallery",
                "mouseDrag": true,
                "controls": false,
                "navContainer": "#customize-thumbnails",
                "navAsThumbnails": true,
                "autoplay": false,
                "autoWidth": false,
                "speed": 400,
            }));
        });

        // Mobile only.  Due to the design we need 2 separate image blocks, one for desktop and one for mobile
        let tnsProductGalleryBlockMainMobile = document.querySelectorAll('.image-gallery-mobile');
        tnsProductGalleryBlockMainMobile.forEach(slider => {
            carousels.push(tns({
                "container": "#mobile-gallery",
                "items": 1,
                "mode": "gallery",
                "mouseDrag": true,
                "nav": true,
                "navPosition": 'bottom',
                "controls": false,
                "autoplay": false,
                "autoWidth": false,
                "speed": 400,
            }));
        });
    }
}
